module.exports = __webpack_public_path__ + "static/img/tshirt.cc2792c9.webp";